import React from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'
import HrSuuntiApi from './HrSuuntiApi'
import DimensionMap from '../dimensionMap/DimensionMap'

const HrSuunti = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()

  const items = [
    {
      label: t('integrationsPage:api'),
      key: 'api',
      children: <HrSuuntiApi allowAuthentication={false} credentialsRequestUrl="/hrsuunti/authentication/{companyId}" />
    },
    {
      label: t('global:costCentres'),
      key: 'dimensions',
      children: (
        <DimensionMap
          getDimensionsUrl="/hrsuunti/dimensions/{companyId}"
          updateDimensionsUrl="/hrsuunti/dimensions/{companyId}/{id}"
          dataKey="id"
        />
      )
    }
  ]

  return (
    <>
      <a href={integrationDocs.external('hrsuunti')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Tabs items={items} destroyOnHidden />
    </>
  )
}

export default HrSuunti
